import { render, staticRenderFns } from "./myInterestedArea.vue?vue&type=template&id=8f50700e&scoped=true&"
import script from "./myInterestedArea.vue?vue&type=script&lang=js&"
export * from "./myInterestedArea.vue?vue&type=script&lang=js&"
import style0 from "./myInterestedArea.vue?vue&type=style&index=0&id=8f50700e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50700e",
  null
  
)

export default component.exports